import DictionaryItem from "../model/dictionary/DictionaryItem";
import {Option, option} from "ts-option";
import {isDefined} from "./Utils";
import {api} from "../api/api";

export default class TaskUtils {

	public static getGroupedTasks(activityTemplates: DictionaryItem[],
		jobActivityTemplates: DictionaryItem[],
		callback: (tgbt: Option<{ [key: string]: DictionaryItem[] }>) => void) {
		Promise.all(activityTemplates.map(
			at => api.instance.activityTemplateApi.fetchActivityTemplateTasks(at.id)).concat(
			jobActivityTemplates.map(jat => api.instance.activityTemplateApi.fetchJobActivityTemplateTasks(jat.id)))
		).then(results => {
				const tgbt: { [key: string]: DictionaryItem[] } = {};

				results.forEach((tasks, atIndex) => tasks.forEach(t => {
					if (atIndex > activityTemplates.length - 1) {
						isDefined(tgbt[t.id]) ?
							tgbt[t.id] = tgbt[t.id].concat(jobActivityTemplates[atIndex - activityTemplates.length]) :
							tgbt[t.id] = [jobActivityTemplates[atIndex - activityTemplates.length]]
					}
					else {
						isDefined(tgbt[t.id]) ?
							tgbt[t.id] = tgbt[t.id].concat(activityTemplates[atIndex]) :
							tgbt[t.id] = [activityTemplates[atIndex]]
					}

				}));
				callback(option(tgbt));
			}
		)
	}
}
